import React from 'react';
import { NavLink } from 'react-router-dom';

const MenuItem = ({ icon, title, path }) => (
  <NavLink to={path} className="uppercase text-sm md:text-base ">
    {({ isActive }) => {
      return isActive ? (
        <div
          className="flex gap-3 md:gap3 bg-gradient-to-r from-contrast2  text-font1 
        p-3 md:px-4 md:py-3 items-center"
        >
          <div>{icon}</div>
          <div>{title}</div>
        </div>
      ) : (
        <div
          className="flex gap-3 text-font1 duration-100 hover:bg-gradient-to-r hover:from-contrast2
        p-3 md:px-4 md:py-3 items-center"
        >
          <div>{icon}</div>
          <div>{title}</div>
        </div>
      );
    }}
  </NavLink>
);

export default MenuItem;
